module.exports = __webpack_public_path__ + "media/landing_page/venture-beat-logo-74bcb624.svg";